import type { DiffItemRef } from '~/api/types'
import { Badge } from '~/components/ui/badge'
import { Checkbox } from '~/components/ui/checkbox'

// ── 전체선택 바(공통) ─────────────────────────────────────────────────────────

export function SelectAllBar({
    label,
    total,
    selected,
    onToggleAll,
}: {
    label: string
    total: number
    selected: number
    onToggleAll: (checked: boolean) => void
}) {
    const allChecked = total > 0 && selected === total
    return (
        <div className='border-border bg-muted/40 flex items-center gap-2 rounded-[var(--radius)] border px-3 py-2'>
            <Checkbox
                checked={allChecked}
                indeterminate={selected > 0 && !allChecked}
                onChange={(e) => onToggleAll(e.target.checked)}
                label={
                    <span className='text-foreground text-sm font-bold'>
                        {label}
                    </span>
                }
            />
            <span className='text-muted-foreground ml-auto text-xs'>
                {selected}/{total} 선택
            </span>
        </div>
    )
}

// ── 식별 헤더(공통) ───────────────────────────────────────────────────────────

export function ItemIdentity({ item }: { item: DiffItemRef }) {
    return (
        <div className='flex flex-wrap items-center gap-2'>
            <Badge tone='neutral'>{item.part || '-'}</Badge>
            <Badge tone='gray'>{item.classification || '-'}</Badge>
            <span className='text-muted-foreground text-xs'>
                #{item.itemNumber || '-'} · {item.scale || '-'}
            </span>
            <span className='text-foreground text-sm font-bold'>
                {item.title || '(제목 없음)'}
            </span>
        </div>
    )
}

export function EmptyTab({ text }: { text: string }) {
    return (
        <p className='text-muted-foreground py-8 text-center text-sm'>{text}</p>
    )
}
